export const environment = {
  production: false
};

export const IDENTITY_POOL_ID = 'ap-northeast-2:310e6713-5d6a-41cb-9391-2c8750c1645f';
export const USER_POOL_ID = 'ap-northeast-2_oM73VQAMU';
export const CLIENT_ID = '3qjcenqj4f6sg8l54qe8aii8vu';
export const REGION = 'ap-northeast-2';
export const MANUAL_PDF_URL_HOME = 'https://test-uconsole.joyfit-service.jp/pdf/unconsole_manual.pdf';
export const MANUAL_PDF_URL = 'https://houjin-manual.s3.us-east-2.amazonaws.com/external-share/c726f415-b185-47b3-9306-e654da981f95/260600_JF_WellnessPASS_A4_nkol_X4.pdf';
export const MANUAL_SALE_PDF_URL = 'https://test-uconsole.joyfit-service.jp/pdf/unconsole_manual_sale.pdf';
export const TERMS_PDF_URL = 'https://test-uconsole.joyfit-service.jp/pdf/notes.pdf';
export const API_URL = 'https://e92f786122.execute-api.ap-northeast-2.amazonaws.com/test';
export const S3_BUCKET = 'test-uconsole.joyfit-service.jp';
export const TERMS_1DAYPASS= 'https://houjin-manual.s3.us-east-2.amazonaws.com/external-share/8b9d0b52-b5ed-464a-9fe3-056b8c69c1de/JOYFIT%20Wellness%20Pass%20%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%EF%BC%88202622%E7%A2%BA%E5%AE%9A%E7%89%88%EF%BC%89.pdf';